import { defaultEntityState } from '@core/state/entities/entity';
import {
  mergeEntityState,
  removeEntitiesByFilter,
} from '@core/state/entities/entity.helpers';
import { stageActions } from '@core/actions/stage.actions';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { createReducer, on } from '@ngrx/store';
import { entityKey } from '@core/state/entities/entity-name-map';
import { IStageAnnotationStats } from '@core/state/entities/stage-annotation-stats/stage-annotation-stats.entity';

export const stageAnnotationStatsEntityReducer = createReducer(
  defaultEntityState<IStageAnnotationStats>(),
  on(
    stageActions.receivedFullStats,
    projectDetailActions.fullProjectStatsReceived,
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    (state, props) =>
      mergeEntityState(entityKey.stageAnnotationStats, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  )
);
